module.exports = __webpack_public_path__ + "img/dash.03a4ec6c.png";